import { Pipe, PipeTransform } from '@angular/core';
import { slugify } from '../../common';

@Pipe({
  name: 'slugify',
  standalone: true,
})
export class SlugifyPipe implements PipeTransform {
  transform(value: string, defaultValue?: string): unknown {
    if (!value && defaultValue) return defaultValue;
    return slugify(value);
  }
}
